export const CLEAR_SESSION_ERROR = "sessionError/CLOSE_SNACKBAR";

export const clearSessionError = () => ({
  type: CLEAR_SESSION_ERROR,
  payload: {},
});
